export enum TvColDefVisEnum {
    Visible,
    Hidden,
}
